import { EntityBrief } from './../../tamalelibs/models/entity-brief.model';
import { Subject } from 'rxjs';

export class SingleEntityDropdownFilterConfig {
    data: EntityBrief[];
    hideInput: boolean;
    disabledInput: boolean;

    onChangeValue$: Subject<any>;
    open$: Subject<any> = new Subject<any>();
    clear$: Subject<any> = new Subject<any>();

    constructor(hideInput?: boolean, disabledInput?: boolean) {
        this.data = [];
        this.hideInput = !!hideInput;
        this.disabledInput = !!disabledInput;

        this.onChangeValue$ = new Subject<any>();
    }
}
